// extracted by mini-css-extract-plugin
export var chip = "_3k-0";
export var filterDropdown = "_3k-5";
export var filterItem = "_3k-6";
export var icon = "_3k-1";
export var removeButton = "_3k-3";
export var removeIcon = "_3k-4";
export var separator = "_3k-2";